import { Button, InputChip, Stack, tokens } from '@cast/design-system';
import { ClearAllButton } from '@cast/shared-search-ui';

import type { ClustersAppliedFilterChip } from '../../hooks/useClustersAppliedFilterChips';

const appliedFilterChipSx = {
  height: 24,
  border: '1px solid',
  borderColor: tokens.theme.border.structural.neutral,
  borderRadius: '4px',
  px: '8px',
  gap: '4px',
  '& .DsChip-Content': {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
  },
  '& .DsChip-EndIconWrapper': {
    marginLeft: 0,
  },
  '& .DsChip-DestroyIcon': {
    width: 12,
    height: 12,
  },
};

type ClustersAppliedFilterChipsProps = {
  chips: ClustersAppliedFilterChip[];
};

export const ClustersAppliedFilterChips = ({
  chips,
}: ClustersAppliedFilterChipsProps) => {
  if (!chips.length) {
    return null;
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      flexWrap="wrap"
      gap="11px"
      data-testid="clusters-applied-filter-chips"
    >
      {chips.map((chip) => (
        <InputChip
          key={chip.id}
          title={chip.title}
          value={chip.value}
          delimiter={chip.delimiter}
          size="sm"
          testId={`clusters-filter-chip-${chip.id}`}
          titleProps={{ variant: 'P12M' }}
          valueProps={{ variant: 'P12R' }}
          sx={appliedFilterChipSx}
          onDestroy={chip.onRemove}
        />
      ))}

      <ClearAllButton
        button={
          <Button
            variant="text"
            size="sm"
            testId="clusters-clear-filters-button"
          >
            Clear Filters
          </Button>
        }
      />
    </Stack>
  );
};
